const SIGNATURE_NAME_PART = /^[\p{L}][\p{L}'’-]*$/u;

export const isValidSignatureName = (value) => {
  if (typeof value !== "string") {
    return false;
  }

  const parts = value.trim().replace(/\s+/g, " ").split(" ");

  return (
    parts.length === 2 && parts.every((part) => SIGNATURE_NAME_PART.test(part))
  );
};
